// imports section Start
import * as React from "react";
import {
  Box,
  FormControl,
  Link,
  Breadcrumbs,
  InputAdornment,
  Stack,
  Button,
  Grid,
  AppBar,
  Slide,
  Alert,
  Snackbar,
  CircularProgress,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Checkbox,
  Paper,
  IconButton,
  Autocomplete,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate, useLocation } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import Navbar from "../../components/common/Navbar";
import ViewData from "../../components/grids/ViewDatagrid";
import { Giftvoucherdata } from "../../assets/Griddata";
import { useStyles } from "../../assets/styles/Theme";
import { useState, useEffect } from "react";
import {
  externaldeleteApi,
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { SETTINGS_API_18, SETTINGS_API_28 } from "../../api/ApiModel";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import SearchAppBar from "../../components/common/search";
// imports section End

function ViewGiftVoucher() {
  // Hooks start
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();
  const [data, setData] = useState(null);
  const [allvouchers, setAllVouchers] = useState(null);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { selectedItem, CERTIFICATECODE } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]); // To track selected rows
  const [rows1, setRows1] = useState([]);
  const SYS_USER = useSelector((state) => state.user) || {};
  const [error2, setError2] = useState(null);
  const { COMPCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [rows, setRows] = useState([]);
  const [sts, setSts] = useState("N");
  const [selectedOrderStatusCode, setSelectedOrderStatusCode] = useState(null);

  useEffect(() => {
    setRows([]);
    setIsLoading(true);
    fetchData();
  }, [CERTIFICATECODE, sts]); // Run fetchData when CERTIFICATECODE changes

  const fetchData = async () => {
    try {
      const vouchers = await externalgetApi(SETTINGS_API_28, "get", {
        COMPCODE,
        STS: sts, // Use the dynamic STS value from state
      });
      setAllVouchers(vouchers); // Map the fetched data to rows for the table
      setIsLoading(false);

      if (CERTIFICATECODE) {
        const result = await externalgetApi(SETTINGS_API_18, "get", {
          COMPCODE,
          CERTIFICATECODE,
          STS: sts, // Use the dynamic STS value from state
        });
        setRows(mapResultToRows(result)); // Map the fetched data to rows for the table
        setIsLoading(false);
        console.log("Fetched Data:", result);
      } else {
        throw new Error("Certificate Code not available");
      }
    } catch (err) {
      setError(err.message || err);
      setIsLoading(false);
    }
  };

  const mapResultToRows = (result) => {
    // Ensure result is an array
    if (!Array.isArray(result)) {
      return []; // Return empty array if result is not valid
    }

    return result.map((item, index) => ({
      id: index + 1,
      VOUCHERNO: item.VOUCHERNO,
      BARCODE: item.BARCODE,
    }));
  };
  const gotToPage = () => {
    navigate("/vGiftcertificate");
  };

  const checkVoucherExists = (vNo, bCode,id) => {
    return allvouchers?.some(
      (item) =>
        (item.VOUCHERNO === vNo || item.BARCODE === bCode) &&
        item.CERTIFICATECODE !== id
    );
  };

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    VOUCHERNO: "",
    BARCODE: "",
  });

  useEffect(() => {
    if (selectedItem) {
      console.log("code", selectedItem.CERTIFICATECODE);
      setSelectedItemDetails({
        CERTIFICATECODE: String(selectedItem.CERTIFICATECODE),
        VOUCHERNO: String(selectedItem.VOUCHERNO || ""),
        BARCODE: selectedItem.BARCODE,
      });
    }
  }, [selectedItem]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // ✅ Clear error for this field
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    // ✅ Update state
    setSelectedItemDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlenumInputValidation = (event) => {
    const { name, value } = event.target;

    const regex = /^[0-9]*$/;

    if (!regex.test(value)) {
      setErrors((prev) => ({
        ...prev,
        [name]: "Only numbers are allowed.",
      }));
      return;
    }

    // ✅ Clear both errors
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setError2(""); // optional (can remove completely)

    handleInputChange(event);
  };

  const handleConfirmClick = async () => {
    const { VOUCHERNO, BARCODE } = selectedItemDetails;

    const requiredFields = [
      { name: "VOUCHERNO", value: VOUCHERNO, label: "Gift Voucher Number" },
      { name: "BARCODE", value: BARCODE, label: "Gift Voucher Barcode" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Please Fill All the Required Fields.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }

const { id } = selectedItemDetails;

const isVoucherDuplicate = checkVoucherExists(VOUCHERNO, null, id);
const isBarcodeDuplicate = checkVoucherExists(null, BARCODE, id);

if (isVoucherDuplicate || isBarcodeDuplicate) {
  let message = "";

  if (isVoucherDuplicate && isBarcodeDuplicate) {
    message = "Voucher Number and Barcode already exist.";
  } else if (isVoucherDuplicate) {
    message = "Voucher Number already exists.";
  } else if (isBarcodeDuplicate) {
    message = "Barcode  already exists.";
  }

  setSnackbarMessage(message);
  setOpenErrorSnackbar(true);
  return;
}



    const staticValues = {
      CERTIFICATECODE: String(CERTIFICATECODE), // Ensure certificate code is handled
      giftvouchercode: "",
      STS: "N",
      Enuser: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_18, payload);
      console.log("Success:", responseData);
      setSnackbarMessage("Created Successfully!");
      setOpenSnackbar(true);
      setSelectedItemDetails({
        VOUCHERNO: "",

        BARCODE: "",
      });
      fetchData();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDelete = async (voucherNo) => {
    try {
      // Assuming externaldeleteApi is your API call for deleting
      await externaldeleteApi(SETTINGS_API_18, "DELETE", {
        CERTIFICATECODE: CERTIFICATECODE,
        VOUCHERNO: voucherNo, // Pass the selected voucher number
        STS: "D",
        ENUSER: USERNAME,
        LOCDATE: new Date().toISOString(),
      });

      // Remove the deleted row from the state
      setRows((prevRows) =>
        prevRows.filter((row) => row.VOUCHERNO !== voucherNo)
      );

      fetchData(); // Refresh the data after deletion

      // Show success message
      setSnackbarMessage("Voucher deleted successfully!");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Failed to delete item:", error);
      setSnackbarMessage("Failed to delete the item");
      setOpenErrorSnackbar(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOrderStatusCode(null);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      VOUCHERNO: "",

      BARCODE: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };
  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Gift Certificates </Link>
                <Link underline="none">Gift Vouchers</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack2}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  size="medium"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.box_container_add}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={styles.col_title}>
              <Typography variant="title" align="left">
                Gift Certificate : {selectedItem.GIFTNAME}
              </Typography>
            </Box>
          </Grid>

          {/* Form Section */}
          <Grid item xs={12} sm={12} md={5}>
            <Box
              // p={2}
              sx={{
                ...styles.col_1,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                textAlign: "left",
                // padding: 2,
                marginLeft: 0,
                height: { xs: "35vh", sm: "35vh", md: "70vh" },
                borderRadius: "4px",
                boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
                background: theme.palette.background.paper,

                borderRight: theme.palette.divider,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography
                    sx={{
                      ...theme.typography.h2,
                      color: theme.palette.text.primary,
                      // p: 2,
                    }}
                  >
                    Add Gift Voucher
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label={
                      <span>
                        Gift Voucher Number{" "}
                        <span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    size="small"
                    fullWidth
                    variant="outlined"
                    name="VOUCHERNO"
                    value={selectedItemDetails.VOUCHERNO} // Fallback to an empty string if undefined
                    onChange={handlenumInputValidation}
                    error={Boolean(errors.VOUCHERNO)}
                    helperText={errors.VOUCHERNO}
                  />
                </Grid>

                <Grid item xs={12}>
                  {" "}
                  <TextField
                    label={
                      <span>
                        Gift Voucher Barcode{" "}
                        <span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    size="small"
                    fullWidth
                    variant="outlined"
                    autoComplete="off"
                    name="BARCODE"
                    value={selectedItemDetails.BARCODE}
                    onChange={handleInputChange}
                    error={Boolean(errors.BARCODE)}
                    helperText={errors.BARCODE}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Button
                    sx={styles.btn_secondary}
                    size="medium"
                    variant="outlined"
                    onClick={handleClearClick}
                  >
                    Clear
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    sx={styles.btn_primary}
                    size="medium"
                    variant="contained"
                    onClick={handleConfirmClick}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} md={7}>
            <Box p={1} sx={styles.st_page_table}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  sx={{
                    ...theme.typography.h2,
                    color: theme.palette.text.primary,
                    mb: 1,
                    padding: { xs: 1, sm: 1, md: 0 },
                  }}
                >
                  Gift Vouchers
                </Typography>
                <Divider />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                display="flex"
                justifyContent="space-between"
              >
         

<Box
  p={1}
  display="flex"
  width="100%"
  gap={2}
  flexDirection={{ xs: "column", sm: "column", md: "row" }}
  alignItems="center"
  justifyContent="center"
>
  {[
    { label: "Outstanding Vouchers", value: "N" },
    { label: "Redeemed Vouchers", value: "Y" },
    { label: "Deleted Vouchers", value: "D" },
  ].map((tab) => {
    const isActive = sts === tab.value;

    return (
      <Button
        key={tab.value}
        size="medium"
        variant="contained"
        onClick={() => setSts(tab.value)}
        sx={isActive ? styles.btn_primary_t : styles.btn_secondary_t}
      >
        {tab.label}
      </Button>
    );
  })}
</Box>


              </Grid>
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", maxWidth: "100px" }}>
                        Voucher No
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="right">
                        Barcode
                      </TableCell>
                      {sts === "N" && (
                        <TableCell sx={{ fontWeight: "bold" }} align="right">
                          Actions
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {isLoading ? (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    ) : error ? (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          Error: {error}
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell>{row.VOUCHERNO}</TableCell>
                          <TableCell align="right">{row.BARCODE}</TableCell>
                          {sts === "N" && (
                            <TableCell align="right">
                              <Tooltip title="Delete" arrow>
                                <IconButton
                                  onClick={() => handleDelete(row.VOUCHERNO)}
                                >
                                  <DeleteIcon
                                    sx={{ color: theme.palette.system.danger }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          )}
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
}

export default ViewGiftVoucher;
